import { defineComponent as _defineComponent } from 'vue'
import { FeeEntry, HistoricalTransaction, ExportListType, AuthorityType } from 'ah-api-gateways';
import FeeReason from 'ah-trades/src/components/fees/FeeReason.vue';
import BankAccountRail from 'ah-beneficiaries/src/components/bankAccounts/BankAccountRail.vue';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { computed, ref, watch } from 'vue';
import { useTradeState } from '../..';
import { VButton } from 'ah-common-lib/src/common/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeeTransactionDetails',
  props: {
    fee: null,
    referenceWalletId: null
  },
  setup(__props: any) {

const props = __props as {
  fee: FeeEntry;
  /**
   * Wallet ID for wallet outgoing/incoming reference
   *
   * As all fees come from or go to clients/partners GBP wallet, a single walletId can be used to determine
   * whether these fees are outgoing or incoming, using the fromWalletId property
   */
  referenceWalletId: string;
};



const tradeState = useTradeState();

const showTransactionDetailsDownloadPopover = ref(false);

const tx = ref<HistoricalTransaction | null>(null);

const requestManager = useRequestManager({
  exposeToParent: ['loadFeeTX'],
  onRetryFromParentManager: (k: string) => {
    if (k === 'loadFeeTX') {
      onFeeChange();
    }
  },
});

const canDownloadStatement = computed(() =>
  tradeState.store.useAuthStore().hasAuthorities(AuthorityType.EXPORT_TRANSACTIONS)
);

// TODO composition API
// const isSmallScreen = computed(() => $mediaQuery.is('smDown'));
const isSmallScreen = computed(() => false);

const isPayedFee = computed(() => props.fee.fromWalletId === props.referenceWalletId);

const amount = computed(() => (isPayedFee.value ? -props.fee.amount : props.fee.amount));

function onFeeChange() {
  if (props.fee.feeTransactionId && isPayedFee.value) {
    requestManager.manager
      .sameOrCancelAndNew(
        'loadFeeTX',
        tradeState.services.wallet.getWalletTransaction(props.fee.feeTransactionId),
        props.fee.feeTransactionId
      )
      .subscribe((res) => (tx.value = res));
  }
}
watch(
  () => props.fee,
  () => {
    onFeeChange();
  },
  { immediate: true }
);

function toggleTransactionDetailsDownloadPopover(value?: boolean) {
  setTimeout(() => {
    showTransactionDetailsDownloadPopover.value = value ?? !showTransactionDetailsDownloadPopover.value;
  });
}

function downloadTransactionDetails(type: ExportListType) {
  showTransactionDetailsDownloadPopover.value = false;
  if (tx.value) {
    requestManager.manager
      .sameOrCancelAndNew(
        'downloadTransactionTrade',
        tradeState.services.wallet.downloadFeeTransactionDetails(props.fee.id, type),
        tx.value.tradeId
      )
      .subscribe();
  }
}

return { __sfc: true,props, tradeState, showTransactionDetailsDownloadPopover, tx, requestManager, canDownloadStatement, isSmallScreen, isPayedFee, amount, onFeeChange, toggleTransactionDetailsDownloadPopover, downloadTransactionDetails, ExportListType, FeeReason, BankAccountRail, formatCurrencyValue, formatDate, VButton }
}

})